import { ApplePayRequiredFields } from '../../../applePay/components/applePayRequiredFields';
import { ClickToPayRequiredFields } from '../../../clickToPay/components/clickToPayRequiredFields.component';
import { GooglePayRequiredFields } from '../../../googlePay/components/googlePayRequiredFields.component';
import { digitalWallets } from '../../types/digitalWallets.types';

export const DigitalWalletsRequiredFields = ({
  digitalWallet,
  isDigitalWalletValid,
  setIsDigitalWalletValid,
}: {
  digitalWallet: digitalWallets;
  isDigitalWalletValid: boolean;
  setIsDigitalWalletValid: (value: boolean) => void;
}) => {
  const digitalWallets = {
    clickToPay: () => (
      <ClickToPayRequiredFields
        setIsDigitalWalletValid={setIsDigitalWalletValid}
      />
    ),
    applePay: () => (
      <ApplePayRequiredFields
        setIsDigitalWalletValid={setIsDigitalWalletValid}
      />
    ),
    googlePay: () => (
      <GooglePayRequiredFields
        setIsDigitalWalletValid={setIsDigitalWalletValid}
      />
    ),
  };
  return digitalWallet && digitalWallets[digitalWallet]();
};
